<!-- Primary -->
<ng-container *ngIf="color === 'primary'" >
  <mat-checkbox color="primary" 
    [(ngModel)]="value"
    class="md-checkbox md-checkbox__primary" 
    [ngClass]="{'md-checkbox__disabled': disabled}"
    [disabled]="disabled">
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </mat-checkbox>
</ng-container>

<ng-container *ngIf="color === 'primary-stroked'">
  
</ng-container>

<ng-container *ngIf="color === 'primary-text'">
  
</ng-container>
<ng-container *ngIf="color === 'primary-opacity'">
  
</ng-container>
<!-- Secondary -->
<ng-container  *ngIf="color === 'accent'">
  <mat-checkbox color="accent" 
    [(ngModel)]="value"
    class="md-checkbox md-checkbox__accent" 
    [ngClass]="{'md-checkbox__disabled': disabled}"
    [disabled]="disabled">
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </mat-checkbox>
</ng-container>

<ng-container *ngIf="color === 'accent-stroked'">
  
</ng-container>

<ng-container *ngIf="color === 'accent-text'">
  
</ng-container>
<ng-container *ngIf="color === 'accent-opacity'">
  
</ng-container>
<!-- Warn -->
<ng-container *ngIf="color === 'warn'">
  <mat-checkbox color="warn" 
    [(ngModel)]="value"
    class="md-checkbox md-checkbox__warn" 
    [ngClass]="{'md-checkbox__disabled': disabled}"
    [disabled]="disabled">
    <ng-container [ngTemplateOutlet]="buttonContent"></ng-container>
  </mat-checkbox>
</ng-container>

<ng-container *ngIf="color === 'warn-stroked'">
  
</ng-container>

<ng-container *ngIf="color === 'warn-text'">
  
</ng-container>
<ng-container *ngIf="color === 'warn-opacity'">
  
</ng-container>
<ng-template #buttonContent>
  <ng-content></ng-content>
</ng-template>